var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 6.5,
    r: 4,
    fill: "#407EDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0464 19.5C12.0158 19.2543 12 19.004 12 18.75C12 16.1837 13.6111 13.9938 15.877 13.1364C14.6 12.7079 13.0533 12.5 11.25 12.5C5.4 12.5 2.25 14.25 2.25 19.5H12.0464Z",
    fill: "#407EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2778 18.6252C21.2965 18.0985 21.5933 17.6184 22.063 17.3544C22.1191 17.3175 22.1752 17.3 22.2314 17.2638L21.764 16.4468L21.2778 15.6297L21.1087 15.7387C20.6369 16.0075 20.054 16.0146 19.5755 15.7572C19.1085 15.4778 18.8254 14.9822 18.8286 14.4497C18.8256 14.3826 18.832 14.3154 18.8476 14.25H16.9028C16.9028 14.3045 16.9218 14.3771 16.9218 14.4497C16.92 14.9811 16.6377 15.4746 16.1739 15.7568C15.6933 16.005 15.1155 15.9982 14.6413 15.7387C14.5824 15.7066 14.5261 15.6702 14.473 15.6297L13.9862 16.4466L13.5 17.2636C13.5599 17.2867 13.6164 17.3172 13.6683 17.3543C14.1381 17.6182 14.4348 18.0984 14.4536 18.625C14.4348 19.1516 14.1381 19.6318 13.6683 19.8957C13.6122 19.9327 13.5561 19.9502 13.5 19.9864L13.9862 20.8034L14.4724 21.6203L14.6413 21.5117C15.1131 21.2428 15.696 21.2358 16.1745 21.4932C16.6417 21.7722 16.9252 22.2677 16.9224 22.8003C16.9253 22.8674 16.919 22.9346 16.9034 23H18.8472C18.8472 22.9455 18.8282 22.8729 18.8282 22.8003C18.83 22.2689 19.1123 21.7754 19.5761 21.4932C20.0569 21.2449 20.635 21.2519 21.1093 21.5117L21.2776 21.6207L21.7638 20.8037L22.25 19.9868C22.1901 19.9636 22.1336 19.9332 22.0817 19.8961C21.6016 19.6398 21.2962 19.1568 21.2778 18.6252ZM17.875 20.4479C16.8682 20.4479 16.0521 19.6317 16.0521 18.625C16.0521 17.6182 16.8682 16.8021 17.875 16.8021C18.8817 16.8021 19.6979 17.6182 19.6979 18.625C19.7012 19.1095 19.5102 19.5751 19.1677 19.9177C18.8251 20.2602 18.3595 20.4512 17.875 20.4479Z",
    fill: "#407EDB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettingIcon);
export default __webpack_public_path__ + "static/media/user_setting_icon.050e67fc68772247b9d3f0b828fcc4e0.svg";
export { ForwardRef as ReactComponent };